<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="production_img_inner">
        <div class="img_desc hidden-xs-only">覆盖多种运营领域与应用场景</div>
        <div class="img_tit">网联工业  赋能制造</div>
        <div class="img_desc hidden-sm-and-up">覆盖多种运营领域与应用场景</div>
        <div class="img_desc hidden-xs-only">深度赋能行业，更懂您的需求，重点行业深耕，适配多项业务场景，助力企业智能化与数字化转型进程</div>
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>


    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">热门解决方案</div>
          <div class="production_desc">重点行业深耕，适配多项业务场景</div>
        </div>
      </div>
    </div>
    <div class="production_box hidden-sm-and-up">
    <img src="../../assets/img/mobile/s1.png" @click="$router.push('/Solutions/erp').catch(() => {})">
    <img src="../../assets/img/mobile/s2.png" @click="$router.push('/Solutions/mes').catch(() => {})">
    <img src="../../assets/img/mobile/s3.png" @click="$router.push('/Solutions/scm').catch(() => {})">
    <img src="../../assets/img/mobile/s4.png" @click="$router.push('/Solutions/wms').catch(() => {})">
    <img src="../../assets/img/mobile/s5.png" @click="$router.push('/Solutions/aps').catch(() => {})">
    <img src="../../assets/img/mobile/s6.png" @click="$router.push('/Solutions/crm').catch(() => {})">
    </div>
    <div class="production_box hidden-xs-only">
      <el-row :gutter="20">
        <el-col :span="12" class="remen-item">
          <div  @click="$router.push('/Solutions/erp').catch(() => {})">
          <img src="../../assets/img/solution/rm1.jpg"/>
          <div class="text-area">
            <div>企业资源计划管理ERP</div>
            <div class="desc">实现跨部门整合数据，主动识别关键经营信息、降低企业<br>决策成本并提高运营率。</div>
          </div>
          </div>
        </el-col>
        <el-col :span="6" class="remen-item">
          <div @click="$router.push('/Solutions/mes').catch(() => {})">
          <img src="../../assets/img/solution/rm2.jpg" />
          <div class="text-area">
            <div>制造执行系统MES</div>
            <div class="desc">提高可见性、资产和设备利用率等，<br>优化您的制造执行过程。</div>
          </div>
          </div>
        </el-col>
        <el-col :span="6" class="remen-item">
          <div  @click="$router.push('/Solutions/scm').catch(() => {})">
            <img src="../../assets/img/solution/rm3.jpg" />
            <div class="text-area">
              <div>供应链管理系统SCM</div>
              <div class="desc">引入数字技术、自动化系统以及成熟的物联<br>设备，实现企业供应链管理水平全面提升。</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="remen-item">
          <div  @click="$router.push('/Solutions/wms').catch(() => {})">
            <img src="../../assets/img/solution/rm4.jpg"/>
            <div class="text-area" >
              <div>仓库管理系统WMS</div>
              <div class="desc">基于物联网、大数据技术，实现库存实时监控<br>及调度优化，提效降本，支持多仓协同。</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="remen-item">
          <div  @click="$router.push('/Solutions/aps').catch(() => {})">
          <img src="../../assets/img/solution/rm5.jpg" />
          <div class="text-area">
            <div>高级计划排程APS</div>
            <div class="desc">基于智能算法优化生产资源调度与排程，<br>提升效率及响应能力，实现高效排程。</div>
          </div>
          </div>
        </el-col>
        <el-col :span="12" class="remen-item">
          <div  @click="$router.push('/Solutions/crm').catch(() => {})">
          <img src="../../assets/img/solution/rm6.jpg" />
          <div class="text-area">
            <div>客户关系管理CRM</div>
            <div class="desc">整合客户数据，优化销售、服务流程，通过自动化管理<br>提升企业效率与客户满意度，助力业务持续增长。</div>
          </div>
          </div>
        </el-col>
      </el-row>

    </div>
    <div class="tedian">
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title">全部解决方案</div>
            <div class="production_desc">覆盖多行业、多场景的解决方案</div>
          </div>
        </div>
      </div>

      <div class="production_card">
        <div class="item-content">
          <div class="sub-item-yzs" @click="$router.push('/Solutions/erp').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-1.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">企业资源计划管理ERP</div>
                <div class="down-card">制造业数字化转型的核心引擎</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" @click="$router.push('/Solutions/mes').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-2.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">制造执行系统MES</div>
                <div class="down-card">车间级智能管控的神经中枢</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" @click="$router.push('/Solutions/scm').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-3.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">供应链管理系统SCM </div>
                <div class="down-card">全链路协同与敏捷响应的战略中枢</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" style="margin-right: 0" @click="$router.push('/Solutions/wms').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-4.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">仓储管理系统WMS</div>
                <div class="down-card">仓储智能化的调度中枢</div></el-col>
            </el-row>
          </div>
        </div>
        <div class="item-content">
          <div class="sub-item-yzs" @click="$router.push('/Solutions/crm').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-5.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">客户关系管理CRM</div>
                <div class="down-card">客户价值挖掘与全周期服务的智能中枢</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" @click="$router.push('/Solutions/plm').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-6.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">产品生命周期管理PLM</div>
                <div class="down-card">产品全生命周期管理的智能中枢</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" @click="$router.push('/Solutions/aps').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-7.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">高级计划排程APS</div>
                <div class="down-card">智能制造的核心决策引擎</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" style="margin-right: 0" @click="$router.push('/Solutions/srm').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-8.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">供应商关系管理SRM</div>
                <div class="down-card">供应链协同与风险管控的智能中枢</div></el-col>
            </el-row>
          </div>
        </div>
        <div class="item-content">
          <div class="sub-item-yzs" @click="$router.push('/Solutions/qms').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-5.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">质量管理系统QMS</div>
                <div class="down-card">质量全流程管控的数字化基石</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" @click="$router.push('/Solutions/wrzs').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-6.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">无人值守计量节点</div>
                <div class="down-card">全流程自动化计量的智能枢纽</div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" @click="$router.push('/Solutions/sjzt').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-7.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">数据中台</div>
                <div class="down-card">企业数据资产化的核心引擎 </div></el-col>
            </el-row>
          </div>
          <div class="sub-item-yzs" style="margin-right: 0" @click="$router.push('/Solutions/dsjfx').catch(() => {})">
            <el-row>
              <el-col :span="6" :xs="24"><img  src="../../assets/img/solution/all-8.png"/></el-col>
              <el-col :span="18" :xs="24"> <div class="up-card">大数据分析平台</div>
                <div class="down-card">数据驱动的智能决策中枢</div></el-col>
            </el-row>
          </div>
        </div>

      </div>
    </div>
    <div class="tedian1" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      currentSub:""
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  methods:{
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tedian1{
  padding-top: 70px;
  background-color: rgba(245, 247, 250, 1);
}
.tedian{
  margin-top: 40px;
  background: url('../../assets/img/solution/all-bg.jpg') 0 0 no-repeat;
  background-size: 100% 100%;
  background-color:#F5F7FA;
  padding: 5px 0 50px 0 ;
  .production_title_wrap{
    margin-top: 30px !important;
    margin-bottom: 10px !important;
  }

}
.production_wrap {
  width: 100%;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    background-color:#F5F7FA;
  }
  .production_img {
    width: 100%;
    //cursor: pointer;
    height: 420px;
    background: url('../../assets/img/solution/solution-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: start;
    justify-content: start;
    flex-direction: column;
    position: relative;

    @media screen and (max-width: 768px) {
      height: 40vw;
    }
    .img_tit {
      font-size: 40px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
    .img_desc {
      font-size: 20px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.9rem;
      }
    }
    .img_btn {
      width: 150px;
      height: 40px;
      margin-top: 20px;
      background: #00A4FF;
      color: #fff;
      bottom: 15%;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      font-size: 14px;
      &:hover {
        color: #fff;
        font-weight: bold;
        background: #24b1ff;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 28px;
        font-size: 0.8rem;
        border-radius: 2PX;
        margin-top: 10PX;
      }
    }
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }
  .production_box {
    margin: auto;
    width: 70%;
    margin-top: 40px;
    margin-bottom: 10px;

    img{
      margin-bottom: 10px;
      width: 100%;
      height: 180px;
      border-radius: 3px;
      &:hover{
        box-shadow: 0px 5px 6px 4px rgba(12, 28, 56, 0.2);
        border: 1px solid #fff;
        @media screen and (max-width: 768px) {
          box-shadow: unset;
          border: 0;
        }
      }
    }
    @media screen and (max-width: 768px) {
      background-color: #F5F7FA;
      width: 95%;
      margin: auto;
      padding-top: 10PX;
      img{
        width: 100%;
        height: auto;
        margin-top: 5PX;
      }
    }
    .remen-item{
      cursor: pointer;
      margin-top: 2px;
      .text-area{
        padding-left: 25px;
        font-size: 24px;
        color: #fff;
        position: absolute;margin-top: -152px;
        .desc{
          margin-top: 10px;
          font-size: 14px;
          line-height: 25px;
        }
      }

    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
  }
  .production_card {

    width: 70%;
    margin: 0px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 20px 0 0 0;
      @media screen and (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 0;
      }
      .sub-item-yzs{
        cursor: pointer;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 4 - 10px); /* 减去间距 */
        margin-right: 20px;
        padding: 20px 6px;
        @media screen and (max-width: 768px) {
          width: calc(100% / 2 - 20PX); /* 减去间距 */
          box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.056);
          margin-right: 0;
          margin-top: 15PX;
          padding: 10PX 3PX;
          text-align: center;
          border-radius: 3PX;
        }
        .down-card{
          color: #808080;
          line-height: 20px;
          font-size: 13px;
          letter-spacing: 1px;
          @media screen and (max-width: 768px) {
          justify-content: center;
          font-size: 0.8rem;
            line-height: 1.5rem;
        }

        }
        img{
          width: 100%;
          margin-right: 5px;
          @media screen and (max-width: 768px) {
            width: 35%;
          }
        }
        .up-card{
          padding-top: 4px;
          display: flex;
          line-height: 40px;
          font-size: 16px;
          color: #16181A;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            justify-content: center;
            font-size: 0.9rem;
            line-height: 1.5rem;

          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

}
.production_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .production_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -48px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;
}
.padding80{
  padding-top: 80px
}
</style>